import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoginService } from "@core/services";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-register-step-2",
  templateUrl: "./register-step-2.component.html",
  styleUrl: "./register-step-2.component.scss",
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegisterStep2Component implements OnInit {
  mailAddress: string = "";

  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.mailAddress = this.route.snapshot.queryParamMap.get("mailAddress") ?? "";
  }

  continueWithLogin() {
    this.loginService.login(this.mailAddress, "/register-step-3", "login");
  }
}
